module.exports = __webpack_public_path__ + "img/banner-two1.ba447a09.png";